import React from "react";
import { Form, Button } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { HTTPURL, REQUEST_OPTIONS } from "../constants/matcher";
import { useForm } from "react-hook-form";

export default function ForgetPassword() 
{
    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
    } = useForm({ defaultValues: { email: "" } });

    const onSubmit = (data) =>
    {
        componentDidMount(data);
    }

    const componentDidMount = (requestData) =>
    {
        REQUEST_OPTIONS.method = 'POST';
        REQUEST_OPTIONS.body = JSON.stringify(requestData);

      fetch(HTTPURL+'user/forget-password', REQUEST_OPTIONS)
        .then(async response => {
            const isJson = response.headers.get('content-type')?.includes('application/json');
            const data = isJson && await response.json();
            if (!response.ok) {
                const error = (data && data.message) || response.status;
                return Promise.reject(error);
            }
            if(data.status===true)
            {
                setValue('email', '') 
                toast.success(data.message)
            }else{
               toast.error(data.message)
            }
        })
        .catch(error => {
            console.error('There was an error!', error);
        });
    }

    return (
      <section className="h-100 bg-dark">
          {/* <ToastContainer /> */}
          <div className="container py-5 h-100">
              <div className="row d-flex justify-content-center align-items-center h-100">
                  <div className="col">
                      <div className="card card-registration my-4">
                          <div className="row g-0">
                              <div className="col-xl-6 d-none d-xl-block">
                                  <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-registration/img4.webp"
                                      alt="" className="img-fluid"
                                  />
                              </div>

                              <div className="col-xl-6">
                                  <Form onSubmit={handleSubmit(onSubmit)}>
                                      <div className="card-body p-md-5 text-black">
                                          <h3 className="mb-5 text-uppercase">Forget Password</h3>
                                          <div className="form-outline mb-4">
                                              <Form.Field>
                                                  <label className="form-label" htmlFor="Email Address">Email Address</label>
                                                  <input
                                                      placeholder='Email Address'
                                                      type="email"
                                                      {...register("email",
                                                        {
                                                            required: true,
                                                            pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                                                        })
                                                      }
                                                      className="form-control form-control-lg"
                                                  />
                                              </Form.Field>
                                              {errors.email && errors.email.type === "required" && <span className="validation-error">This is required</span>}
                                              {errors.email && errors.email.type === "pattern" && <span className="validation-error">Must be a valid email</span>}
                                          </div>
                                          <div className="d-flex justify-content-end pt-3">
                                            <Button type='submit' className="btn btn-warning btn-lg ms-2 sap-btn-dark">Send Link</Button>
                                          </div>
                                      </div>
                                  </Form>
                                </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
      </section>
  )
}